import { render, staticRenderFns } from "./TeamDirectory.vue?vue&type=template&id=2903bdb2&scoped=true&"
import script from "./TeamDirectory.vue?vue&type=script&lang=js&"
export * from "./TeamDirectory.vue?vue&type=script&lang=js&"
import style0 from "./TeamDirectory.vue?vue&type=style&index=0&id=2903bdb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2903bdb2",
  null
  
)

export default component.exports